slick = {};

slick.elements = {
    init: function () {
        slick.elements.loadSlick();
    },
    syncGalleryHeight: function($slickElem) {
        // Sincronizar altura de la galería con la columna de texto
        let $container = $slickElem.closest('.text-with-image-content');
        let $textCol = $container.find('.text-with-image-col.text');
        let $imageCol = $container.find('.text-with-image-col.image');
        let $galleryContainer = $slickElem.closest('.image-gallery-container');
        let $dotsContainer = $galleryContainer.find('.image-gallery-dots');
        
        if ($textCol.length && $imageCol.length && $galleryContainer.length) {
            let textHeight = $textCol.outerHeight();
            let dotsHeight = $dotsContainer.outerHeight(true); // incluye margin y padding
            let availableHeight = textHeight - dotsHeight;
            
            // Establecer altura de la columna de imagen
            $imageCol.css('height', textHeight + 'px');
            
            // Establecer altura del wrapper de slick
            $slickElem.css('height', availableHeight + 'px');
            
            // Forzar recalculo de slick
            $slickElem.slick('setPosition');
        }
    },
    loadSlick: function () {
        let $slickElem = $('.js-slickCustom');

        $slickElem.each(function() {
            let $currentSlick = $(this);
            
            // Prevenir doble inicialización
            if ($currentSlick.hasClass('slick-initialized')) {
                return;
            }

            let elementsToShow = $currentSlick.data('elements') || 1;
            let elementsToShowMobile = $currentSlick.data('elements-mobile') || 1;
            let dotsEnabled = $currentSlick.data('dots') || false;
            let arrowsEnabled = $currentSlick.data('arrows') || false;
            let infiniteEnabled = $currentSlick.data('infinite') || false;
            let elementsToScroll = $currentSlick.data('elements-scroll') || 1;
            let speed = $currentSlick.data('speed') || 400;
            let dotsContainer = $currentSlick.data('dots-container') || '.js-slickDots';

            $currentSlick.on('init', function(event, slickInstance) {
                $currentSlick.addClass('slick-initialized-custom');
                // Sincronizar altura después de inicializar
                setTimeout(function() {
                    slick.elements.syncGalleryHeight($currentSlick);
                }, 150);
            });

            $currentSlick.slick({
                arrows: arrowsEnabled,
                dots: dotsEnabled,
                infinite: infiniteEnabled,
                speed: speed,
                slidesToShow: elementsToShow,
                slidesToScroll: elementsToScroll,
                appendDots: dotsContainer,
                appendArrows: '.js-slickDots',
                adaptiveHeight: false,
                fade: false,
                cssEase: 'ease',
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 911,
                        settings: {
                            slidesToShow: elementsToShowMobile,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });

        // Recalcular altura en resize con debounce
        let resizeTimer;
        $(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                $('.js-slickCustom').each(function() {
                    slick.elements.syncGalleryHeight($(this));
                });
            }, 250);
        });
    }
};

slick.init = function () {
    slick.elements.init();
};

slick.binds = function () {
    //news.binds();
};

$(document).ready(function () {
    if ($('.js-slickCustom').length > 0) {
        slick.binds();
        slick.init();
    }
});